import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'app';
  bodyClasses: string[] = [];

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router
  ) {}

  updateBodyClasses() {
    this.bodyClasses.length = 0;
    this.bodyClasses = this.collectRouteData('bodyClass');
  }

  ngOnInit() {
    this.router.events.subscribe((change: unknown) => {
      if (change instanceof NavigationEnd) {
        this.bodyClasses.forEach((className) => this.renderer.removeClass(this.el.nativeElement, className));
        this.updateBodyClasses();
        this.bodyClasses.forEach((className) => this.renderer.addClass(this.el.nativeElement, className));
      }
    });
  }

  private collectRouteData(key: string) {
    let route: ActivatedRouteSnapshot | null = this.router.routerState.snapshot.root;
    const returnArray = [];

    while (route) {
      if (route.data && route.data[key]) {
        returnArray.push(route.data[key]);
      }
      route = route.firstChild;
    }

    return returnArray;
  }
}
